module.exports = __webpack_public_path__ + "img/ueber-mich-2_640.6be87b5d.webp";